import React from 'react'
import styles from './ContractorHistoryRow.module.css'
import moment from "moment";

export const ContractorHistoryRow = ({dateTime, title, action}) => {
    return (
        <div className={styles.root}>
            <div className={styles.cell}>{moment(dateTime).format('DD.MM.YYYY')}</div>
            <div className={styles.cell}>{moment(dateTime).format('HH:mm')}</div>
            <div className={styles.cell}>{title}</div>
            <div className={styles.cell}>{action}</div>
        </div>
    )
}